/**
 * Routes
 */

// components
var Backlog = resolve => require(['./views/backlog/index.vue'], resolve)
var BacklogOld = resolve => require(['./views/backlog/new-index.vue'], resolve)
var NotFound = resolve => require(['./views/404.vue'], resolve)
var Forbidden = resolve => require(['./views/Forbidden.vue'], resolve)
var Login = resolve => require(['./views/Login.vue'], resolve)
var Otp = resolve => require(['./views/Otp.vue'], resolve)
var ChangePassword = resolve => require(['./views/ChangePassword.vue'], resolve)
var SsoLogin = resolve => require(['./views/SsoLogin.vue'], resolve)

module.exports = [
  { name: 'register',
    path: '/register', component: resolve => require(['./views/Register.vue'], resolve)
  },
  { path: '/login', component: Login },
  { path: '/sso-callback', component: SsoLogin },
  { path: '/', redirect: '/backlog' },
  { path: '/backlog', component: Backlog, 
     meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:false,
        hq_top:true,
        purchaser:true,
        qc:false,
        r_and_d:true,
        client_p:true,
        hq_warehouse: true,
        auditor:false
      }
    }
  },
  { path: '/backlog-new', component: BacklogOld, 
     meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:false,
        hq_top:true,
        purchaser:true,
        qc:false,
        r_and_d:true,
        client_p:true,
        hq_warehouse: true,
        auditor:false
      }
    }
  },
  { path: '/change-password', component: ChangePassword, 
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/settings', 
    component: resolve => require(['./views/settings/index.vue'], resolve), 
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  {
    path: '/clients',
    component: resolve => require(['./views/clients/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/clients/index.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'add',
        component: resolve => require(['./views/clients/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        name: 'edit-clients',
        component: resolve => require(['./views/clients/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      }
    ]
  },
  {
    path: '/items',
    component: resolve => require(['./views/inventory/items/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/inventory/items/index.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'add',
        component: resolve => require(['./views/inventory/items/add.vue'], resolve),
         meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        name: 'edit-items',
        component: resolve => require(['./views/inventory/items/edit.vue'], resolve),
         meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:true,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'duplicate/:id',
        name: 'duplicate-item',
        component: resolve => require(['./views/inventory/items/duplicate.vue'], resolve),
         meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
    ]
  },
  {
    path: '/quotations',
    component: resolve => require(['./views/inventory/quotations/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/inventory/quotations/index.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'add',
        component: resolve => require(['./views/inventory/quotations/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        name: 'edit-quotations',
        component: resolve => require(['./views/inventory/quotations/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      }
    ]
  },
  {
    path: '/vendors',
    component: resolve => require(['./views/inventory/vendors/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/inventory/vendors/index.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'add',
        component: resolve => require(['./views/inventory/vendors/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        name: 'edit-vendors',
        component: resolve => require(['./views/inventory/vendors/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:false,
            client_p:true,
            auditor:false
          }
        }
      }
    ]
  },
  {
    path: '/purchasers',
    component: resolve => require(['./views/purchasers/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/purchasers/Index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/purchasers/Add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-purchasers',
        component: resolve => require(['./views/purchasers/Edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/users',
    component: resolve => require(['./views/users/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/users/Index.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:false,
            client:false,
            hq_top:true,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'add',
        component: resolve => require(['./views/users/Add.vue'], resolve),
         meta:{
          roles: {
            admin:true,
            supervisor:false,
            client:false,
            hq_top:true,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        name: 'edit-users',
        component: resolve => require(['./views/users/Edit.vue'], resolve),
         meta:{
          roles: {
            admin:true,
            supervisor:false,
            client:false,
            hq_top:true,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      }
    ]
  },
  {
    path: '/backlog',
    component: resolve => require(['./views/backlog/template.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:false,
        hq_top:true,
        purchaser:true,
        qc:false,
        r_and_d:true,
        client_p:true,
        hq_warehouse: true,
        auditor:false
      }
    },
    children: [
      {
        path: '/backlog/sales-order',
        component: resolve => require(['./views/backlog/index.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:true,
            purchaser:true,
            qc:false,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/backlog/sales-order/add',
        component: resolve => require(['./views/backlog/sales-order/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/backlog/sales-order/edit/:id',
        name: 'edit-sales-order',
        component: resolve => require(['./views/backlog/sales-order/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:true,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/backlog/sales-order/log/:id',
        name: 'logs-sales-order',
        component: resolve => require(['./views/backlog/sales-order/log.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/som/edit/:id',
        name: 'som-edit',
        component: resolve => require(['./views/som/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:true,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/sub-som/edit/:id',
        name: 'som-edit',
        component: resolve => require(['./views/sub-som/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:true,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: '/documents/edit/:id',
        name: 'documents-edit',
        component: resolve => require(['./views/documents/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/rfq/edit/:id',
        name: 'rfq-edit',
        component: resolve => require(['./views/rfq/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/backlog/commercial-offers',
        component: resolve => require(['./views/backlog/commercial-offer/index.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
    ]
  },
  {
    path: '/purchase-order',
    component: resolve => require(['./views/purchase-order/template.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:false,
        hq_top:true,
        purchaser:true,
        qc:false,
        r_and_d:false,
        client_p:true,
        auditor:false
      }
    },
    children: [
       {
        path: '/purchase-order/edit/:id',
        name: 'edit-purchase-order',
        component: resolve => require(['./views/purchase-order/edit.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:true,
            purchaser:true,
            qc:false,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: '/purchase-order/log/:id',
        name: 'edit-purchase-log',
        component: resolve => require(['./views/purchase-order/log.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:true,
            auditor:false
          }
        }
      }
    ]
  },
  {
    path: '/buyersheet',
    component: resolve => require(['./views/buyersheet/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/buyersheet/index.vue'], resolve)
      },
      {
        path: '/buyersheet/purchase-order/create',
        component: resolve => require(['./views/buyersheet/purchase-order/create.vue'], resolve)
      },
      {
        path: '/buyersheet/purchase-order/edit/:id',
        name: 'edit-purchase-order-buyer',
        component: resolve => require(['./views/buyersheet/purchase-order/edit.vue'], resolve)
      }
    ]
  },
  { path: '/auth-commercial-offers', component: resolve => require(['./views/backlog/commercial-offer/index.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:true,
        r_and_d:true,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/client/commercial-offers', component: resolve => require(['./views/backlog/commercial-offer/index.vue'], resolve),
    meta:{
      roles: {
        admin:false,
        supervisor:false,
        client:true,
        hq_top:true,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:true,
        auditor:false
      }
    }
  },
  { path: '/samples-documents', component: resolve => require(['./views/samples-documents/index.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        auditor:false
      }
    }
  },
   { path: '/delivery-details', component: resolve => require(['./views/delivery-details/add.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        auditor:false
      }
    }
  },
  { path: '/delivery-details/:id', component: resolve => require(['./views/delivery-details/edit.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        auditor:false
      }
    }
  },
  { path: '/qr-management/:id/audit', component: resolve => require(['./views/qr-management/audit.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        auditor:false
      }
    }
  },
  { path: '/samples', component: resolve => require(['./views/samples/template.vue'], resolve),
    children: [
      {
        path: 'edit/:id',
        component: resolve => require(['./views/samples/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'delivery-details',
        component: resolve => require(['./views/samples/delivery-details.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'inspection-results',
        component: resolve => require(['./views/samples/inspection-results.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'proforma/add',
        component: resolve => require(['./views/samples/proforma/add.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'proforma/edit/:id',
        component: resolve => require(['./views/samples/proforma/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:false,
            purchaser:true,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'arrival-details/add',
        component: resolve => require(['./views/samples/arrival-details/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            purchaser:true,
            client:false,
            hq_top:false,
            qc:false,
            r_and_d:false,
            client_p:false,
            auditor:false
          }
        }
      },
      {
        path: 'arrival-details/edit/:id',
        component: resolve => require(['./views/samples/arrival-details/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            purchaser:true,
            client:false,
            hq_top:false,
            qc:false,
            r_and_d:true,
            client_p:false,
            auditor:false
          }
        }
      }
    ]
  },
  { path: '/qr-management', component: resolve => require(['./views/qr-management/template.vue'], resolve),
    children: [
       {
        path: '',
        component: resolve => require(['./views/qr-management/index.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'add',
        component: resolve => require(['./views/qr-management/add.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        component: resolve => require(['./views/qr-management/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      }
    ]
  },
  { path: '/purchase-order-sheets', component: resolve => require(['./views/buyersheet/purchase-order/purchase-order-sheets.vue'], resolve) },
  { path: '/commercial-offers', component: resolve => require(['./views/backlog/commercial-offer/index.vue'], resolve) },  
  { name: 'add lot number', path: '/lot-numbers/add', component: resolve => require(['./views/lot-numbers/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        auditor:false
      }
    }
  },
  { name: 'edit lot number',path: '/lot-numbers/edit/:id', component: resolve => require(['./views/lot-numbers/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        auditor:false
      }
    }
  },
  { path: '*', component: NotFound },
  { path: '/forbidden', component: Forbidden, 
     meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        auditor:true
      }
    }
  },
  { path: '/otp', component: Otp, 
     meta:{
      roles: {
        admin:true,
        supervisor:true,
        client:true,
        hq_top:true,
        purchaser:true,
        qc:true,
        r_and_d:true,
        client_p:true,
        hq_warehouse:true,
        auditor:true
      }
    }
  },
  {
    path: '/payment-plan',
    component: resolve => require(['./views/payment-plan/template.vue'], resolve),
    children: [
      {
        path: 'add',
        component: resolve => require(['./views/payment-plan/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        component: resolve => require(['./views/payment-plan/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      }
    ]  
  },
  {
    path: '/arrival-details',
    component: resolve => require(['./views/arrival-detail/template.vue'], resolve),
    children: [
      {
        path: 'add',
        component: resolve => require(['./views/arrival-detail/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        component: resolve => require(['./views/arrival-detail/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            auditor:false
          }
        }
      }
    ]  
  },
  {
    path: '/logistics',
    component: resolve => require(['./views/logistics/template.vue'], resolve),
    children: [
      {
        path: 'add',
        component: resolve => require(['./views/logistics/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            hq_warehouse: true,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        component: resolve => require(['./views/logistics/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:true,
            hq_top:true,
            purchaser:true,
            qc:true,
            r_and_d:true,
            client_p:true,
            hq_warehouse: true,
            auditor:false
          }
        }
      }
    ]  
  },
  {
    path: '/so_log',
    component: resolve => require(['./views/so_log/template.vue'], resolve),
    children: [
      {
        path: 'add',
        component: resolve => require(['./views/so_log/add.vue'], resolve),
        meta:{
          roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:true,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:true,
            auditor:false
          }
        }
      },
      {
        path: 'edit/:id',
        component: resolve => require(['./views/so_log/edit.vue'], resolve),
        meta:{
           roles: {
            admin:true,
            supervisor:true,
            client:false,
            hq_top:true,
            purchaser:false,
            qc:false,
            r_and_d:false,
            client_p:true,
            auditor:false
          }
        }
      }
    ]
  },
  {
    path: '/item-logs/:id',
    component: resolve => require(['./views/item-logs/view.vue'], resolve),
    meta:{
        roles: {
          admin:true,
          supervisor:false,
          client:false,
          hq_top:false,
          purchaser:false,
          qc:false,
          r_and_d:false,
          client_p:false,
          auditor:false
        }
    }
  },
  {
    path: '/exports/:id',
    component: resolve => require(['./views/exports/view.vue'], resolve),
    meta:{
        roles: {
          admin:true,
          supervisor:true,
          client:true,
          hq_top:true,
          purchaser:true,
          qc:true,
          r_and_d:true,
          client_p:true,
          auditor:false
        }
    }
  },
  {
    path: '/file/download',
    component: resolve => require(['./views/exports/download.vue'], resolve),
    meta:{
        roles: {
          admin:true,
          supervisor:true,
          client:true,
          hq_top:true,
          purchaser:true,
          qc:true,
          r_and_d:true,
          client_p:true,
          auditor:false
        }
    }
  },
  { path: '/documents-archive', component: resolve => require(['./views/documents-archive/index.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:true
      }
    }
  },
  { path: '/documents-archive/services/create', component: resolve => require(['./views/documents-archive/services/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/services/edit/:id', component: resolve => require(['./views/documents-archive/services/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/documents/create', component: resolve => require(['./views/documents-archive/documents/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/documents/edit/:id', component: resolve => require(['./views/documents-archive/documents/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/credit-notes/create', component: resolve => require(['./views/documents-archive/credit-notes/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/credit-notes/edit/:id', component: resolve => require(['./views/documents-archive/credit-notes/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/debit-notes/create', component: resolve => require(['./views/documents-archive/debit-notes/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/debit-notes/edit/:id', component: resolve => require(['./views/documents-archive/debit-notes/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/payments/create', component: resolve => require(['./views/documents-archive/payments/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
  { path: '/documents-archive/payments/edit/:id', component: resolve => require(['./views/documents-archive/payments/form.vue'], resolve),
    meta:{
      roles: {
        admin:true,
        supervisor:false,
        client:false,
        hq_top:false,
        purchaser:false,
        qc:false,
        r_and_d:false,
        client_p:false,
        auditor:false
      }
    }
  },
]




// WEBPACK FOOTER //
// ./src/routes.js